import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./ProductReportSummary.module.css";

const ProductReportSummary = ({
  showAutoComplete = () => {},
  refreshData = () => {},
}) => {
  // const { addRef } = useContext(ProductsContext);
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              label="Refresh"
              color="black"
              onClick={refreshData}
              endIcon={<Shortcut keys={["Alt", "R"]} disabled />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              // ref={addRef}
              label="Add new Product"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Ctrl", "M"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default ProductReportSummary;
